(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.baseElem = factory());
})(this, (function () { 'use strict';

    // Dom shortcuts
    const w = window, d = document, body = d.body, root = d.documentElement, toType = (object) => ({}).toString.call(object).match(/\s([a-zA-Z]+)/)[1].toLowerCase(), oa = Object.assign, af = Array.from, isArr = Array.isArray, isStr = (str) => typeof str === 'string', isObj = (obj) => toType(obj) === 'object';

    const eventFnCache = new WeakMap();
    const cssSplitRgx = /([\.\#][\w-_\s]+)/g;
    const 
    // region Props
    CSS_ACTION_STATES = Object.freeze({
        active: 'active',
        starting: 'starting',
        ending: 'ending'
    }), cssActionStates = (nameSpace, baseObj = CSS_ACTION_STATES) => {
        const retObj = {};
        const prefix = nameSpace ? nameSpace + '-' : '';
        for (const key in baseObj) {
            if (Object.hasOwn(baseObj, key)) {
                oa(retObj, {
                    [key]: prefix + baseObj[key]
                });
            }
        }
        return retObj;
    }, 
    // 
    // region Finding Elems
    // 
    findBy$1 = (type, find, base = d) => {
        return type === 'class' ? af(base.getElementsByClassName(find)) :
            type === 'id' ? d.getElementById(find) :
                type === 'tag' ? af(base.getElementsByTagName(find)) :
                    null;
    }, find$1 = (el, base = d) => {
        return af(base.querySelectorAll(el));
    }, findOne$1 = (el, base = d) => {
        return base.querySelector(el);
    }, map$1 = (elems, fn, unique = false) => {
        let i = 0, elem, prevRes;
        const retElems = [];
        while (elem = elems[i]) {
            const res = fn(elem, i++);
            if (!res)
                continue; // only truthy value
            if (unique) {
                if (res !== prevRes || !elems.find(el => el === res))
                    retElems.push(res);
                prevRes = res;
            }
            else
                retElems.push(res);
        }
        return retElems;
    }, parents$1 = (elem, selector, untilElem = root) => {
        const untilIsStr = isStr(untilElem);
        const retElems = [];
        while (elem = elem.parentElement) {
            if (elem.matches(selector))
                retElems.unshift(elem);
            if (untilIsStr ? elem.matches(untilElem) : elem === untilElem)
                break;
        }
        return retElems;
    }, siblings$1 = (elem, selector, includeKeyEl = false) => {
        const siblings = af(elem.parentElement.childNodes).filter(el => el instanceof HTMLElement &&
            (selector ? el.matches(selector) : true) &&
            (includeKeyEl ? true : el !== elem));
        return siblings;
    }, next$1 = (elem, selector) => {
        let nextElem = elem.nextElementSibling;
        if (selector)
            while (nextElem) {
                if (nextElem.matches(selector))
                    break;
                nextElem = nextElem.nextElementSibling;
            }
        // always return an element
        return (nextElem ?? elem);
    }, prev$1 = (elem, selector) => {
        let prevElem = elem.previousElementSibling;
        if (selector)
            while (prevElem) {
                if (prevElem.matches(selector))
                    break;
                prevElem = prevElem.previousElementSibling;
            }
        // always return an element
        return (prevElem ?? elem);
    }, 
    // 
    // region CSS and Attrs
    // 
    attr$1 = (elem, attrs) => {
        if (isStr(attrs)) {
            if (attrs === 'value')
                return elem.value;
            return elem.getAttribute(attrs);
        }
        else {
            for (const key in attrs) {
                const val = attrs[key];
                val === null ?
                    elem.removeAttribute(key) :
                    elem.setAttribute(key, val);
            }
        }
    }, css$1 = (elem, attrs) => {
        if (isStr(attrs)) {
            const styles = getComputedStyle(elem);
            return styles.getPropertyValue(attrs);
        }
        else {
            for (const key in attrs) {
                const val = attrs[key];
                if (key.startsWith('--')) {
                    elem.style.setProperty(key, val);
                }
                else {
                    elem.style[key] = val;
                }
            }
        }
        return '';
    }, _cl = (elem) => elem.classList, addClass$1 = (elem, cssNames) => {
        const cl = _cl(elem);
        isArr(cssNames) ? cl.add(...cssNames) : cl.add(cssNames);
    }, rmClass$1 = (elem, cssNames) => {
        const cl = _cl(elem);
        isArr(cssNames) ? cl.remove(...cssNames) : cl.remove(cssNames);
    }, tgClass$1 = (elem, cssNames, toggle) => {
        const cl = _cl(elem);
        if (isArr(cssNames)) {
            for (const cssName of cssNames) {
                cl.toggle(cssName, toggle);
            }
        }
        else {
            cl.toggle(cssNames, toggle);
        }
    }, hasClass$1 = (elem, cssNames) => {
        const cl = _cl(elem);
        return isArr(cssNames) ? cssNames.every(cls => cl.contains(cls)) : cl.contains(cssNames);
    }, elemRects$1 = (elem) => {
        return elem.getBoundingClientRect();
    }, offset$1 = (elem) => {
        const rects = elemRects$1(elem);
        return {
            top: rects.top + w.pageYOffset,
            left: rects.left + w.pageXOffset
        };
    }, 
    // 
    // region Element Creation / Removal
    // 
    make = (selector, propsOrHtml = {}, html) => {
        const [tag, ...attrs] = selector.split(cssSplitRgx), baseAttrs = getTagAttrs(attrs), propsIsHtml = isArr(propsOrHtml) || propsOrHtml instanceof HTMLElement, propsIsContent = isStr(propsOrHtml) || propsIsHtml, makeProps = propsIsContent ? {} : propsOrHtml, props = oa(baseAttrs, makeProps), { style } = props, elem = oa(d.createElement(tag), props), htmlToUse = propsIsContent && !html ? propsOrHtml : (html ? html : '');
        if (style && isObj(style))
            css$1(elem, style);
        if (htmlToUse)
            elem.append(...(isStr(htmlToUse) ? htmlParse$1(htmlToUse) :
                isArr(htmlToUse) ? htmlToUse : [htmlToUse]));
        return elem;
    }, htmlParse$1 = (htmlStr) => {
        const root = (new DOMParser()).parseFromString(htmlStr, 'text/html').body;
        // remove scripts, even though they're non-exectable with the DOMParser
        const scripts = find$1('script', root);
        if (scripts)
            scripts.forEach(s => s.remove());
        const elList = af(root.childNodes);
        return elList;
    }, empty$1 = (elem) => {
        while (elem.firstChild) {
            elem.removeChild(elem.firstChild);
        }
    }, merge = (configOrTarget, ...objects) => {
        const options = isArr(configOrTarget) ? configOrTarget :
            toType(configOrTarget) === 'string' || toType(configOrTarget) === 'boolean' ? [configOrTarget] : [], 
        // end options;
        hasOptions = options.length > 0, getOpt = (configOpt) => hasOptions ? options.some(opt => opt === configOpt) : false, deep = getOpt('deep') || getOpt(true), noNull = getOpt('noNull'), noFalsy = getOpt('noFalsy'), target = hasOptions ? objects.shift() : configOrTarget;
        let mergeObj, i = 0;
        while (mergeObj = objects[i++]) {
            for (const key in mergeObj) {
                const value = mergeObj[key];
                if (deep && isObj(value)) {
                    const targetObj = target[key] ? target[key] : target[key] = {};
                    merge(options, targetObj, value);
                }
                else {
                    target[key] = value;
                    if ((noNull && value === null) || (noFalsy && !value)) {
                        delete target[key];
                    }
                }
            }
        }
        return target;
    }, 
    // 
    // region Event
    // 
    on$1 = (baseEl = body, evtName, fn, delegateEl = null, config = false) => {
        const evt = evtName.split('.')[0];
        const evtFn = (e) => {
            const data = e['___cdata'] || [];
            if (delegateEl && baseEl instanceof HTMLElement) {
                const delegateElems = isStr(delegateEl) ? find$1(delegateEl, baseEl) : delegateEl;
                // if isTrusted then its a native click
                const elTarget = e.isTrusted ? e.target : (e['___synthTarget'] ?? e.target);
                // const delegateElem = getDelegatedElem(baseEl, delegateElems, elTarget);
                const delegateElem = delegateElems.find(elem => elem === elTarget || elem.contains(elTarget));
                if (delegateElem)
                    fn(e, delegateElem, ...data);
            }
            else {
                fn(e, baseEl, ...data);
            }
        };
        if (eventFnCache.has(baseEl)) {
            eventFnCache.get(baseEl).set(evtName, evtFn);
        }
        else {
            eventFnCache.set(baseEl, new Map([[evtName, evtFn]]));
        }
        baseEl.addEventListener(evt, evtFn, config);
    }, off$1 = (target = body, evtName, config = false) => {
        if (eventFnCache.has(target)) {
            const tgtFnMap = eventFnCache.get(target), evt = evtName.split('.')[0], fn = tgtFnMap.get(evtName);
            target.removeEventListener(evt, fn, config);
            tgtFnMap.delete(evtName);
        }
    }, trigger$1 = (target = body, evtName, delegateEl = null, data = [], config = false) => {
        evtName = evtName.trim();
        const delegateEls = delegateEl ? find$1(delegateEl, target instanceof Window ? body : target) : null;
        if (delegateEls && delegateEls.length === 0)
            return;
        const elTarget = delegateEls ? delegateEls[0] : target, [evt, nameSpace = ''] = evtName.split('.'), evtIsSynthetic = /^\[.+\]$/.test(evtName), elEvt = new Event(evtIsSynthetic ? evtName : evt);
        if (data.length)
            oa(elEvt, { ___cdata: data });
        if (nameSpace || evtIsSynthetic) {
            const cache = eventFnCache.get(target);
            if (!cache)
                return;
            const fn = cache.get(evtName);
            oa(elEvt, { ___synthTarget: elTarget });
            if (fn) {
                if (evtIsSynthetic) {
                    target.addEventListener(evtName, fn, config);
                    target.dispatchEvent(elEvt);
                    target.removeEventListener(evtName, fn, config);
                }
                else
                    fn(elEvt, elTarget);
            }
        }
        else
            target.dispatchEvent(elEvt);
    }, 
    // 
    // region Transition
    // 
    useTransition = () => {
        let inTransition = false;
        let tto = null;
        let currEndTransitionFn = () => { };
        return (startFn, endFn, duration = 300) => {
            if (inTransition) {
                currEndTransitionFn();
                clearTimeout(tto);
            }
            startFn();
            currEndTransitionFn = endFn;
            inTransition = true;
            tto = setTimeout(() => {
                currEndTransitionFn();
                inTransition = false;
            }, duration);
        };
    }, useCssAnimate = (elems, baseCss = '') => {
        const transition = useTransition();
        const cssState = cssActionStates(baseCss);
        const cssAnimate = (start, duration = 400, endFn = () => { }) => {
            const cssTarget = start ? cssState.starting : cssState.ending;
            const startAnimate = (elem) => {
                elem.offsetHeight; //reflow
                addClass$1(elem, cssTarget);
                rmClass$1(elem, cssState.active);
            };
            const endAnimate = (elem) => {
                rmClass$1(elem, cssTarget);
                tgClass$1(elem, cssState.active, start);
            };
            transition(() => {
                isArr(elems) ?
                    elems.forEach(startAnimate) :
                    startAnimate(elems);
            }, () => {
                isArr(elems) ?
                    elems.forEach(endAnimate) :
                    endAnimate(elems);
                endFn();
            }, duration);
        };
        return [
            cssAnimate,
            cssState
        ];
    }, animateByFrame = (fn, fps = 60) => {
        fps = Math.min(Math.max(1, fps), 60); // clamp fps between 1 and 60
        let requestAnimate = null;
        let msPrev = performance.now();
        const msPerFrame = 1000 / fps;
        const cancelAnimation = () => cancelAnimationFrame(requestAnimate);
        const refresh = (msNow) => {
            requestAnimate = window.requestAnimationFrame(refresh);
            const msPassed = msNow - msPrev;
            if (msPassed < msPerFrame)
                return;
            const excessTime = msPassed % msPerFrame;
            msPrev = msNow - excessTime;
            fn(cancelAnimation);
        };
        // Initial call
        fn(cancelAnimation);
        refresh(msPrev);
        return cancelAnimation;
    }, 
    // region visibility
    isVisible = (el) => {
        const vis = el.offsetParent !== null ||
            !!(el.offsetWidth ||
                el.offsetHeight ||
                el.getClientRects().length);
        return vis;
    }, isHidden = (el) => !isVisible(el);
    // 
    // Helpers
    // 
    const getTagAttr = (attrList, rm) => attrList.filter(e => e.startsWith(rm)).map(e => e.substring(1));
    const getTagAttrs = (attrList) => {
        const attrs = {}, classes = getTagAttr(attrList, '.'), id = getTagAttr(attrList, '#');
        for (const val of attrList) {
            if (classes.length)
                oa(attrs, { className: classes.join(' ') });
            if (id.length)
                oa(attrs, { id: id[0] });
        }
        return attrs;
    };
    const BaseStatic = {
        CSS_ACTION_STATES,
        addClass: addClass$1,
        attr: attr$1,
        css: css$1,
        cssActionStates,
        empty: empty$1,
        find: find$1,
        findBy: findBy$1,
        findOne: findOne$1,
        hasClass: hasClass$1,
        htmlParse: htmlParse$1,
        isVisible,
        isHidden,
        make,
        map: map$1,
        merge,
        next: next$1,
        parents: parents$1,
        prev: prev$1,
        siblings: siblings$1,
        elemRects: elemRects$1,
        offset: offset$1,
        off: off$1,
        on: on$1,
        trigger: trigger$1,
        rmClass: rmClass$1,
        tgClass: tgClass$1,
        useTransition,
        useCssAnimate,
        animateByFrame,
        //utils
        af, isArr, isStr, isObj, oa, toType
    };

    const { addClass, attr, css, elemRects, offset, empty, find, findBy, findOne, map, next, prev, hasClass, htmlParse, off, on, parents, siblings, trigger, rmClass, tgClass } = BaseStatic;
    const noElemMsg = 'Element is not defined with index: ';
    class BaseElem {
        elem = [];
        constructor(selector, base) {
            if (isStr(selector)) {
                this.elem = find(selector, base);
            }
            else if (selector instanceof BaseElem) {
                this.elem = [...selector.elem];
            }
            else {
                //not checking type for HTMLElement[]
                if (selector) {
                    this.elem = isArr(selector) ? selector : [selector];
                }
            }
            return this;
        }
        // ---------------
        // region Private Methods
        // ---------------
        #iterate(fn) {
            let i = 0, elem;
            while (elem = this.elem[i]) {
                fn(elem, i++);
            }
        }
        #strOrObj(attrs, fn = () => '') {
            if (isStr(attrs)) {
                const elem = this.elem[0];
                return fn(elem, attrs);
            }
            else {
                this.#iterate(elem => fn(elem, attrs));
            }
            return '';
        }
        #content(fn, content) {
            if (content) {
                this.#iterate((elem) => {
                    empty(elem);
                    const nodes = fn(content);
                    isArr(nodes) ? elem.append(...nodes) : elem.append(nodes);
                });
            }
            else {
                // return copy
                return this.elem[0];
            }
            return null;
        }
        // ---------
        // region Selectors
        // ---------
        find(selector, filter) {
            if (isStr(selector)) {
                const elems = this.elem.map(elem => find(selector, elem)).flat();
                return new BaseElem(filter ? elems.filter(filter) : elems);
            }
            else {
                return new BaseElem(this.map(selector, true));
            }
        }
        findBy(type, selector, filter) {
            const elems = this.elem.map(elem => findBy(type, selector, elem)).flat();
            return new BaseElem(filter ? elems.filter(filter) : elems);
        }
        findOne(selector) {
            const elem = this.elem.map(elem => findOne(selector, elem)).filter(Boolean);
            return new BaseElem(elem);
        }
        filter(fn) {
            // not error checking for the document or window
            return new BaseElem(this.elem.filter(fn));
        }
        // -------------------
        // region Array and iteration
        // -------------------
        toArray() {
            return [...this.elem];
        }
        map(fn, unique = false) {
            return map(this.elem, fn, unique);
        }
        parents(selector, untilElem) {
            if (untilElem instanceof BaseElem)
                untilElem = untilElem.elem[0];
            const elems = map(this.elem, (elem) => parents(elem, selector, untilElem));
            return new BaseElem(elems.flat());
        }
        siblings(selector, includeKeyEl = false, index = 0) {
            return new BaseElem(siblings(this.elem[index], selector, includeKeyEl));
        }
        next(selector) {
            return new BaseElem(next(this.elem[0], selector));
        }
        prev(selector) {
            return new BaseElem(prev(this.elem[0], selector));
        }
        get(index) {
            const elem = this.elem[index];
            if (elem)
                return new BaseElem(elem);
            else
                console.warn(noElemMsg + index);
        }
        each(fn) {
            this.#iterate(fn);
            return this;
        }
        css(attrs) {
            const val = this.#strOrObj(attrs, css);
            if (val)
                return val;
            return this;
        }
        addClass(cssNames) {
            this.#iterate(elem => addClass(elem, cssNames));
            return this;
        }
        rmClass(cssNames) {
            this.#iterate(elem => rmClass(elem, cssNames));
            return this;
        }
        tgClass(cssNames, toggle) {
            this.#iterate(elem => tgClass(elem, cssNames, toggle));
            return this;
        }
        hasClass(cssNames, method = 'some') {
            return !isArr(this.elem) ?
                hasClass(this.elem, cssNames) :
                method === 'some' ?
                    this.elem.some(elem => hasClass(elem, cssNames)) :
                    this.elem.every(elem => hasClass(elem, cssNames));
        }
        attr(attrs) {
            const val = this.#strOrObj(attrs, attr);
            if (val)
                return val;
            return this;
        }
        #getOne(index = 0, fn) {
            const elem = this.elem[index];
            if (elem) {
                return fn(elem);
            }
            else {
                console.warn(noElemMsg + index);
                return undefined;
            }
        }
        elemRects(index = 0) {
            return this.#getOne(index, elemRects);
        }
        offset(index = 0) {
            return this.#getOne(index, offset);
        }
        get hasEls() {
            return this.elem.length > 0;
        }
        get size() {
            return this.elem.length;
        }
        // ------------------------------
        // region Removal and Appending Elements
        // ------------------------------
        empty() {
            this.#iterate(empty);
            return this;
        }
        remove() {
            this.#iterate(elem => elem.remove());
            return this;
        }
        insert(html, method = 'append') {
            this.#iterate((elem) => {
                const elems = (isArr(html) ? html.map(getElems).flat() : isStr(html) ? htmlParse(html) : getElems(html));
                if (method === 'append')
                    elem.append(...elems);
                if (method === 'prepend')
                    elem.prepend(...elems);
                if (method === 'after')
                    elem.after(...elems);
                if (method === 'before')
                    elem.before(...elems);
            });
            return this;
        }
        html(html) {
            const retEl = this.#content(htmlParse, html);
            if (retEl)
                return retEl.innerHTML.trim();
            return this;
        }
        text(text) {
            const retEl = this.#content((text) => new Text(text), text);
            if (retEl)
                return retEl.textContent.trim();
            return this;
        }
        // ------
        // region Events
        // ------
        on(evtName, fn, delegateEl = null, config = false) {
            if (isArr(evtName)) {
                for (const evName of evtName) {
                    this.#iterate((elem) => on(elem, evName, fn, delegateEl, config));
                }
            }
            else {
                this.#iterate((elem) => on(elem, evtName, fn, delegateEl, config));
            }
            return this;
        }
        trigger(evtName, delgateEl, data) {
            this.#iterate((elem) => trigger(elem, evtName, delgateEl, data));
            return this;
        }
        off(evtName, config = false) {
            if (isArr(evtName)) {
                for (const evName of evtName) {
                    this.#iterate((elem) => off(elem, evName, config));
                }
            }
            else {
                this.#iterate((elem) => off(elem, evtName, config));
            }
            return this;
        }
    }
    // 
    // Helper
    // 
    const getElems = (el) => el instanceof BaseElem ? el.elem : [el];

    const $be = (selector, base) => new BaseElem(selector, base);
    oa($be, BaseStatic);
    $be.BaseElem = BaseElem;

    return $be;

}));

//# sourceMappingURL=base-elem-js.js.map
